import {XAxisConfig} from '../../../types/GraphTypes';

export function getGraphRendererXDomain(
  xAxis: XAxisConfig | null,
): [number | 'dataMin', number | 'dataMax'] | undefined {
  if (xAxis?.min !== undefined || xAxis?.max !== undefined) {
    // Use 'auto' for dataMin/dataMax to ensure all data is visible
    const min = xAxis.min !== undefined ? xAxis.min : 'dataMin';
    const max = xAxis.max !== undefined ? xAxis.max : 'dataMax';
    return [min, max];
  }
  return undefined;
}
